// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce421130","239":"f53b1f6f","453":"2cb60c69","455":"8ebd9092"}[chunkId] + ".chunk.js";
};